<template>
  <CoursesEnciteItem
    :pageTitle="'Online Courses FOCI'"
    :courseTitle="'FOCI'"
    :courseFullTitle="'Understanding Foreign Ownership, Control, or Influence (FOCI)'"
    :informationCardColor="'#000'"
    :courseItems="items"
  />
</template>
<script>
import CoursesEnciteItem from "./courses-encite-item.vue";
import { enciteFOCICourses } from "../utils/coursesEnciteData";

export default {
  name: "encite-coursesfoci",
  components: {
    CoursesEnciteItem,
  },
  props: {
    query: String,
  },
  data() {
    return {
      items: enciteFOCICourses,
    }
  },
}
</script>
